/* eslint-disable */
<template>
  <MyNavbar></MyNavbar>
  <main>
    <router-view></router-view>
  </main>
  <footer>
    <div id="collumnContainer">
      <div id="solution">
        <img
          src="../public/logo_wanview_white.svg"
          alt="logo Wanview"
          width="170"
          height="38"
          v-on:click="scrollToTop()"
        />
        <p>Une solution proposée par <strong>Wancom</strong></p>
        <p class="muted">
          Expert français en matière d’affichage digital, Wancom a fait le pari
          de développer son propre logiciel. De l’application mobile à
          l’informatique dans ses écrans, tout est développé et maîtrisé chez
          Wancom. Les fonctionnalités du logiciel évoluent pour ses clients et
          avec ses clients. De l’intelligence sur mesure made in Corrèze, made
          in France !
        </p>
      </div>
      <div
        itemscope
        itemtype="https://schema.org/Organization"
        id="dottedBordered"
      >
        <a class="title" itemprop="tel" href="tel:+33555879415"
          >05 55 87 94 15</a
        >
        <a class="title" itemprop="email" href="mailto:contact@wancom.fr"
          >contact@wancom.fr</a
        >
        <a href="#" itemprop="address" class="address"
          >54 av. Georges Pompidou <br />
          19100 Brive-la-Gaillarde</a
        >
      </div>
      <div>
        <div id="linksContainer">
          <a class="footerLink" href="https://www.wancom.fr/">
            <span class="linkName">Wancom</span
            ><span class="rightIcon material-icons-outlined"
              >chevron_right</span
            >
          </a>
          <hr />
          <a class="footerLink" href="https://www.wancom.fr/savoir-faire">
            <span class="linkName">À propos</span
            ><span class="rightIcon material-icons-outlined"
              >chevron_right</span
            >
          </a>
          <hr />
          <a class="footerLink" href="https://www.wancom.fr/equipes">
            <span class="linkName">Nous connaître</span
            ><span class="rightIcon material-icons-outlined"
              >chevron_right</span
            >
          </a>
          <hr />
          <a
            class="footerLink"
            href="https://www.wancom.fr/reponses-indoor"
          >
            <span class="linkName">Nos solutions digitales</span
            ><span class="rightIcon material-icons-outlined"
              >chevron_right</span
            >
          </a>
          <hr />
          <a class="footerLink" href="https://www.wancom.fr/digitaliser-son-lieu-de-vente">
            <span class="linkName">Nos solutions matérielles</span
            ><span class="rightIcon material-icons-outlined"
              >chevron_right</span
            >
          </a>
        </div>
      </div>
    </div>
  </footer>
  <div id="footerBar">
    <p>
      <span
        >2022 Wanview © - Tous droits réservés -
        <span
          ><router-link :to="{ name: 'mention' }">
            Mentions légales</router-link
          ></span
        ></span
      >
    </p>
  </div>
  <div class="cookie-banner">
    <span class="material-icons-outlined cookie-icon"> cookie </span>
    <p>
      Ce site utilise des cookies pour vous garantir la meilleure expérience.
      <a
        href="https://www.google.com/intl/fr/policies/technologies/cookies/"
        target="_blank"
        >En savoir plus</a
      >
    </p>
    <div class="cookie-buttons">
      <button class="accept-all" v-on:click="acceptAllCookies">Accepter</button>
      <button class="refuse-all" v-on:click="refuseAllCookies">Refuser</button>
      <!-- <button class="accept-cookies" v-on:click="showCookies">
        Paramétrer
      </button> -->
    </div>
    <!-- div with class 'hide' and in list of cookies 'Google Analytics', 'reCAPTCHA' with accept/refuse buttons -->
    <div class="cookies-list hide">
      <ul>
        <li>
          <label class="switch">
            <input type="checkbox" checked disabled name="recaptcha" />
            <span class="slider round"></span>
          </label>
          <span>Cookies Obligatoires (nécessaires)</span>
        </li>
        <li>
          <label class="switch">
            <input type="checkbox" checked name="google-analytics" />
            <span class="slider round"></span>
          </label>
          <span>Google Analytics</span>
        </li>
        <li>
          <button class="valid-cookies" v-on:click="setCookie">Valider</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MyNavbar from "@/components/MyNavbar.vue";
export default {
  /* eslint-disable */
  components: {
    MyNavbar,
  },
  mounted() {
    // if cookie is already set in localstorage, don't show banner
    //localStorage.setItem("acceptGoogleAnalytics", "true");
    if (localStorage.getItem("acceptGoogleAnalytics") === "true") {
      this.injectGoogleAnalytics();
      //after hide cookie banner
      document.querySelector(".cookie-banner").classList.add("hide");
    }
  },
  methods: {
    notifications: function (message, duration) {
      // create the notification
      // inject the notification into the DOM
      // setTimeout to remove the notification from the DOM

      var notification = document.createElement("div");
      notification.classList.add("notification");
      notification.innerHTML = message;
      document.body.appendChild(notification);
      setTimeout(() => {
        notification.parentNode.removeChild(notification);
      }, duration);
    },
    // new method setCookie
    showCookies: function (e) {
      document.querySelector(".cookies-list").classList.remove("hide");
      //.cookie-button hide
      document.querySelector(".cookie-buttons").classList.add("hide");
    },
    setCookie: function (e) {
      // check if checkboxes are checked for accept or refuse cookies (recaptcha, google analytics)
      // if both are checked, accept all cookies
      // if none is checked, refuse all cookies
      // if one is checked, accept only the checked one
      if (
        document.querySelector('input[name="google-analytics"]').checked &&
        document.querySelector('input[name="recaptcha"]').checked
      ) {
        this.acceptAllCookies();
      }
      if (
        !document.querySelector('input[name="google-analytics"]').checked &&
        !document.querySelector('input[name="recaptcha"]').checked
      ) {
        this.refuseAllCookies();
      }
      if (
        document.querySelector('input[name="google-analytics"]').checked &&
        !document.querySelector('input[name="recaptcha"]').checked
      ) {
        this.acceptCookies("google-analytics", "true");
      }
      if (
        !document.querySelector('input[name="google-analytics"]').checked &&
        document.querySelector('input[name="recaptcha"]').checked
      ) {
        this.acceptCookies("recaptcha", "true");
      }
      document.querySelector(".cookies-list").classList.add("hide");
    },
    // function acceptAllCookies()
    acceptAllCookies: function (e) {
      document.cookie = "acceptAll=true";
      // hide banner
      document.querySelector(".cookie-banner").style.display = "none";
      // show notification
      this.notifications(
        "Tous les cookies ont été acceptés. Vous pouvez maintenant naviguer sur le site.",
        3000
      );
      this.injectAllCookies();
    },
    // function refuseAllCookies()
    refuseAllCookies: function (e) {
      document.cookie = "acceptAll=false";
      // hide banner
      document.querySelector(".cookie-banner").style.display = "none";
      // show notification
      this.notifications("Tous les cookies ont été refusés.", 3000);
    },
    // function acceptCookies(name, value)
    acceptCookies: function (name, value) {
      document.cookie = name + "=" + value + ";";
      // show notification that cookies are accepted
      // this.notifications(message, duration)
      this.notifications("Les cookies choisi ont été acceptés.", 3000);

      // hide banner
      document.querySelector(".cookie-banner").style.display = "none";
    },
    // function acceptGoogleAnalytics()
    acceptGoogleAnalytics: function (e) {
      this.acceptCookies("acceptGoogleAnalytics", "true");
    },
    // function injectGoogleAnalytics()
    injectGoogleAnalytics: function (e) {
      // inject google analytics script
      // https://www.googletagmanager.com/gtag/js?id=G-5E5E12FNW1
      var script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-5E5E12FNW1";
      script.async = true;
      document.body.appendChild(script);
      // add google analytics script to the DOM
      var gtag = document.createElement("script");
      gtag.innerHTML =
        "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-5E5E12FNW1');";
      document.body.appendChild(gtag);
    },

    // function injectAllCookies()
    injectAllCookies: function (e) {
      // inject all cookies
      // inject google analytics script
      this.injectGoogleAnalytics();

      // save cookies in localStorage
      localStorage.setItem("acceptGoogleAnalytics", "true");
    },

    // function ScrollToTop()
    // function scroll to top
    ScrollToTop: function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss">
@import "./assets/variables.scss";
@font-face {
  font-family: "Material Icons Outlined";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/materialiconsoutlined/v101/gok-H7zzDkdnRel8-DQ6KAXJ69wP1tGnf4ZGhUce.woff2)
    format("woff2");
  font-display: swap;
}

.material-icons-outlined {
  font-family: "Material Icons Outlined";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}
* {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

button {
  @extend %btn;
}
::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: $primary;
}

.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transform: scale(1.1);
  // transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
  z-index: 9999;
  &.show {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
    transition: visibility 0s linear 0s, opacity 0.25s 0s, transform 0.25s;
  }
}

/* Modal Content */
.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 1rem;
  width: 80vw;
  border-radius: 0.5rem;
  .close {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
  }
}

.collapse {
  overflow: hidden;
  width: 100%;
  perspective: 10px;

  button {
    z-index: 1;
    width: 100%;
    height: 100px;
    background-color: whitesmoke;
    border: none;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }

  .collapse-content {
    max-height: 0;
    z-index: -1;
    background-color: #dceff9;
    color: white;
    transition: all 400ms;
    margin-top: 10px;
    border-radius: 7px;
  }
}

main {
  overflow-x: hidden;
}

footer {
  background: transparent linear-gradient(180deg, #0f3353 0%, #0a2946 100%) 0%
    0% no-repeat padding-box;

  display: flex;
  justify-content: center;
  // align-items: center;
  @media screen and (max-width: 800px) {
    flex-flow: column;
    align-items: center;
  }
  div {
    @media screen and (max-width: 1100px) {
      display: block;
    }
    padding-top: 2em;
    padding-bottom: 2em;
    display: flex;
    justify-content: center;
    div {
      @media screen and (max-width: 1100px) {
        display: inline-flex;
        vertical-align: top;
        height: 250px;
        width: 100%;
        padding-left: 0em;
        padding-right: 0em;
        margin-left: auto;
        margin-right: auto;
      }

      @media screen and (max-width: 700px) {
        padding-left: 0em;
        padding-right: 0em;
      }
      width: 300px;
      display: flex;
      flex-flow: column;
      padding-left: 2em;
      padding-right: 2em;
      padding-top: 0px;
      padding-right: 0px;
      padding-bottom: 0px;
      justify-content: flex-start;
      img {
        width: 170px;
        margin-bottom: 7px;
      }
      p,
      a {
        color: $light;
        font-family: "Nunito", sans-serif;
        &.muted {
          margin-top: 7px;
          color: rgba(255, 255, 255, 0.4);
        }
        font-size: 14px;
        &.title {
          font-size: 18px;
          font-weight: bold;
          line-height: 1.44;
          letter-spacing: normal;
        }
      }
    }
  }

  #solution {
    @media screen and (max-width: 1100px) {
      padding-left: 20px;
      padding-right: 20px;
      width: calc(50% - 40px);
    }
    width: 330px;
    padding-right: 20px;
  }
}

#dottedBordered {
  @media screen and (max-width: 1100px) {
    padding-left: 20px;
    padding-right: 20px;
    width: calc(50% - 44px);
    text-align: center;
  }
  border-left: 2px #ffffff40 dashed;
  border-right: 2px #ffffff40 dashed;
  @media screen and (max-width: 1100px) {
    border-right: none;
    // height: auto;
    margin: 1em 0;
  }
  @media screen and (max-width: 700px) {
    border: none;
    border-top: 2px #ffffff40 dashed;
    border-bottom: 2px #ffffff40 dashed;
    padding: 2em 1em;
  }
}

.address {
  font: normal normal normal 14px/20px Nunito;
  color: #ffffffb5;
  margin-top: 7px;
  line-height: 23px;
}

#footerBar {
  width: 100%;
  display: flex;
  height: 37px;
  background: #1a1a1a 0% 0% no-repeat padding-box;
  align-items: center;
  justify-content: center;
  margin: auto;
}

#footerBar p {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font: normal normal 600 14px/20px Nunito;
  color: #ffffff;
  margin: auto;
}

#linksContainer {
  @media screen and (max-width: 1100px) {
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0px;
  }
  @media screen and (max-width: 1400px) {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0px;
  }
  hr {
    opacity: 0.1;
  }
}
.footerLink {
  cursor: pointer;
  height: 25px;
  span {
    vertical-align: top;
  }
  .linkName {
    font: normal normal normal 15px/36px Work Sans;
    margin-top: -5px;
    display: inline-block;
  }
  .rightIcon {
    float: right;
  }
}

@media screen and (max-width: 700px) {
  #collumnContainer {
    div {
      display: flex;
      width: auto;
      margin-right: auto;
      margin-left: auto;
      height: auto;
      // border: none;
      // padding: 0;
      margin-bottom: 20px;
      text-align: left;
    }

    #linksContainer {
      width: 100%;
      width: -moz-available; /* WebKit-based browsers will ignore this. */
      width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
      width: fill-available;
      padding: 0em 1em;
    }
  }
}

a {
  text-decoration: none;
  color: white !important;
}

.cookie-banner {
  background-color: $primary;
  padding: 10px;
  text-align: center;
  font-size: 0.8em;
  font-weight: bold;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 4em);
  @media screen and (max-width: 650px) {
    width: 100%;
    border-radius: 0;
    padding: 1em;
  }
  border-radius: 20px 20px 0 0;
  color: $light;
  font-weight: 200;
  animation: fadeinup 0.5s ease-in-out;
  z-index: 9999;
  a {
    color: $light;
    text-decoration: underline;
    &:hover {
      color: $light;
      text-decoration: none;
    }
  }
  button {
    background-color: $secondary;
    color: $primary;
    border: 2px solid $secondary;
    border-radius: 5px;
    padding: 5px 10px;
    margin-left: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    font-weight: 400;
    &.refuse-all,
    &.accept-cookies {
      background-color: $primary;
      color: $secondary;
      border: 2px solid $secondary;
    }
  }
  .cookies-list {
    ul {
      list-style: none;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
      padding: 0;
      @media screen and (max-width: 650px) {
        max-width: 80%;
      }
      li {
        margin-bottom: 1em;
        display: flex;
        align-items: center;
        width: 100%;
        button {
          margin-left: auto;
        }
      }
    }
  }
}
.hide {
  display: none;
}
.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 20px;
  margin-right: 1em;
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}
.slider {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $dark;
  -webkit-transition: 0.4s;
  transition: 0.4s;

  &::before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: $secondary;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
}

input {
  &:checked + .slider {
    background-color: $primary;
  }
  &:checked + .slider:before {
    -webkit-transform: translateX(25px);
    -ms-transform: translateX(25px);
    transform: translateX(25px);
  }
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  &:before {
    border-radius: 50%;
  }
}

/* notifications */
.notification {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9999;
  width: 25%;
  height: auto;
  font-size: 0.8em;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  animation: fadein 0.5s ease-in-out;
  border-radius: 20px 20px 0 0;
  padding: 1em;
}

/* notification pop-up on corner right bottom with border radius */

@keyframes fadeinup {
  0% {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
    transform: translate(0, 20px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}
/*keyframe fadeindown*/
@keyframes fadeindown {
  0% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
}
</style>
